import { render } from "./Email_Templates.vue?vue&type=template&id=12d2c606"
import script from "./Email_Templates.vue?vue&type=script&lang=js"
export * from "./Email_Templates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__